import React from 'react';
import Shimmer from '../../../Common/Shimmer';

/** The page's own shape while it loads, so nothing jumps when the data lands. */
const HomeSkeleton = () => (
  <div className="tw-flex tw-flex-col tw-gap-3 page-sm:tw-gap-4" aria-busy="true" aria-label="Loading your dashboard">
    <Shimmer height={108} />
    <div className="tw-grid tw-grid-cols-2 tw-gap-3 page-sm:tw-gap-4 page-md:tw-grid-cols-4">
      {[0, 1, 2, 3].map((tile) => <Shimmer key={tile} height={124} />)}
    </div>
    <div className="tw-grid tw-gap-4 page-md:tw-grid-cols-2">
      <Shimmer height={280} />
      <Shimmer height={280} />
    </div>
    <Shimmer height={260} />
  </div>
);

export default HomeSkeleton;
